import { z } from 'zod'

export const childSavingSchema = z.object({
  number_of_children: z.enum(['one', 'two', 'three_or_more']),
  amount_of_money: z.enum(['less_than_50', '100', '200', 'more_than_200']),
  sustainability: z.enum(['very_important', 'important', 'not_so_important', 'dont_know']),
})
